module.exports = __webpack_public_path__ + "static/abi-158a36487678818ae1c404f2db53857d.png";